import { useContext } from 'react';
import { UploadContext } from './provider';
export const useUploadMetricRecords = () => useContext(UploadContext);
